import React, { Fragment, useState, useRef } from 'react';
import {
  Button,
  Checkbox,
  Grid,
  Dialog, DialogActions, DialogContent, DialogTitle,
  FormControl,
  FormControlLabel,
  IconButton,
  MenuItem,
  Snackbar,
  TextField,
  Tooltip,
  Typography,
} from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import { makeStyles } from '@material-ui/core/styles'
import StrappingTable from './StrappingTable';
import { Auth } from 'aws-amplify';
import { useHistory } from "react-router-dom";
import { host } from "../../../data";
import HorizontalTankImg from './Assets/HorizontalTank_ti40042.png';
import ObroundTankImg from './Assets/ObroundTank_ti40043.png';
import VerticalTankImg from './Assets/VerticalTank_ti40781.png';
import { calculateMaxCapacity } from '../../../helpers/calculateMaxCapacity';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  grow: {
    flexGrow: 1,
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 300,

    marginBottom: 10
  },
  formControlTags: {
    margin: theme.spacing(1),
    minWidth: 600,

    marginBottom: 10
  },
  infoControl: {
    margin: theme.spacing(1),
    minWidth: 120,
    marginBottom: 0
  },
  cols: {
    paddingRight: 15
  },
  clickButtons: {
    marginLeft: theme.spacing(2),
  },
  btnActions: {
  },
  inputButton: {
    display: 'flex',
    flexWrap: 'nowrap',
  },
  fluidList: {
    minWidth: 300,
    margin: theme.spacing(1),
    marginBottom: 10
  },
  tankInfo: {
    justify: "flex-start",
    alignItems: "center",
  },
  tankInfoForm: {
    minWidth: 400,
  },
  TankImg: {
    height: '300px',
  },
  snackBar: {
    backgroundColor: theme.palette.secondary.main,
    textColor: theme.palette.primary.contrastText,
  }
}));

const TankSettings = ({ orgInfo, branchInfo, site, siteId, handleExit, dimensionunits, volumeunits, tankId, orgTags,
  tank = {}, fluids, 'tank-shape': tankShape, setPageDataReady, setTabsDataReady, setTankData, addfluid = () => { } }) => {
  const classes = useStyles();
  const { t, i18n } = useTranslation();
  let history = useHistory();
  const [open, setOpen] = useState(false);
  const [dimensionUnit, setDimensionUnits] = useState(tank.DimensionUnit || 'inches');
  const [volumeUnit, setVolumeUnits] = useState(tank.VolumeUnit || 'gallons');
  const [selectedTankShape, setTankShape] = useState(tank.TankShape || 'vertical');
  const [levelVolumeTable, setLevelVolumeTable] = useState(tank.VolumeTable || []);
  const [fluidName, setFluidName] = useState(tank.fluidName || '');
  const [tankName, setTankName] = useState(tank.name || '');
  const rtankName = useRef("");
  const [newFluidName, setNewFluidName] = useState('');
  const rnewFluidName = useRef("");
  const [tankHeight, setTankHeight] = useState(tank.TankHeight || '');
  const rtankHeight = useRef("");
  const [tankDiameter, setTankDiameter] = useState(tank.TankDiameter || '');
  const rtankDiameter = useRef("");
  const [tankLength, setTankLength] = useState(tank.TankLength || '');
  const rtankLength = useRef("");
  const [tankWidth, setTankWidth] = useState(tank.TankWidth || '');
  const rtankWidth = useRef("");
  const [tankCapacity, setTankCapacity] = useState(tank.TankCapacity || '');
  const rtankCapacity = useRef("");
  const [fillCapacity, setFillCapacity] = useState(tank.FillCapacity || '');
  const rfillCapacity = useRef("");
  const [tankTag, setTankTag] = useState(tank.Tags || '');
  const rtankTag = useRef("");
  const [selectAddTag, setSelectAddTag] = useState("");
  const [selectAddTemplate, setSelectAddTemplate] = useState("");
  const [orgTemplates, setOrgTemplates] = useState([]);
  const [newTemplateCheck, setNewTemplateCheck] = useState(false);
  const [tankTemplateName, setTankTemplateName] = useState("");
  const rtankTemplateName = useRef("");
  const [showTankImage, setShowTankImage] = useState('false');
  const [tankImage, setTankImage] = useState();
  const [csvFileName, setCSVFileName] = useState('reports.csv');
  const [csvReportData, setCSVReportData] = useState([]);
  const csvHeaders = [
    { label: t("fluidHeight"), key: 'height' },
    { label: t("volume"), key: 'volume' },
  ];
  const [notification, setNotification] = useState({
    open: false,
    message: ""
  });

  var calculatedMaxCapacity = calculateMaxCapacity(dimensionUnit, volumeUnit, tankHeight, tankWidth, tankDiameter, tankLength, selectedTankShape);

  const handleNotificationClose = () => setNotification({ open: false, message: "" });

  const handleClickOpen = () => setOpen(true);

  const handleClose = () => setOpen(false);

  const handleAddFluid = () => {
    addfluid({ id: fluids.length + 1, name: rnewFluidName.current.value });
    setFluidName(rnewFluidName.current.value);
    setOpen(false);
    setNewFluidName("");
  };

  React.useEffect(() => {
    switch (selectedTankShape) {
      case "vertical":
        setTankImage(VerticalTankImg);
        setShowTankImage(true);
        break;
      case "horizontal":
        setTankImage(HorizontalTankImg);
        setShowTankImage(true);
        break;
      case "obround":
        setTankImage(ObroundTankImg);
        setShowTankImage(true);
        break;
      default:
        setShowTankImage(false);
        setTankImage(undefined);
    }
  }, [selectedTankShape]);

  React.useEffect(() => {
    Auth.currentAuthenticatedUser()
      .then(data => {
        var requestOptions = {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': data.signInUserSession.idToken.jwtToken
          },
        };

        fetch(host + '/orgs/' + orgInfo.orgId + '/templates/', requestOptions)
          .then(results => results.json())
          .then(data => {
            setOrgTemplates(data.templatesList);
          }).catch((error) => {
            console.log(error)
          })
      });
  }, [orgInfo]);

  const handleAddTag = (tag) => {
    var tempTags = tankTag;
    if (tag !== null) {
      if (tempTags !== null && tempTags !== "") {
        tempTags = tempTags + "," + tag;
      }
      else {
        tempTags = tag;
      }
      setTankTag(tempTags);
    }
    setSelectAddTag(tag);
  };

  React.useEffect(() => {
    if (selectedTankShape === 'pulseHUB') {
      setNewTemplateCheck(false);
    }
  }, [selectedTankShape])

  const handleNewTemplateCheck = (event) => {
    setNewTemplateCheck(event.target.checked);
  };

  const handleAddTemplate = (template) => {
    setTankShape(template.TankShape);
    setTankHeight(template.TankHeight);
    setTankLength(template.TankLength);
    setTankWidth(template.TankWidth);
    setTankDiameter(template.TankDiameter);
    setDimensionUnits(template.DimensionUnit);
    setVolumeUnits(template.VolumeUnit);
    setFillCapacity(template.FillCapacity);
    setTankCapacity(template.TankCapacity);
    setLevelVolumeTable(template.VolumeTable);
    setSelectAddTemplate(template.name);
  };

  function createTemplate(sessionToken, fillCap, tTable) {
    var body = JSON.stringify(
      {
        "Name": tankTemplateName,
        "Type": "Tank",
        "Params": [
          {
            "DimensionUnit": dimensionUnit,
            "TankDiameter": tankDiameter,
            "TankLength": tankLength,
            "TankShape": selectedTankShape,
            "TankHeight": tankHeight,
            "TankWidth": tankWidth,
            "VolumeUnit": volumeUnit,
            "TankCapacity": tankCapacity,
            "FillCapacity": fillCap,
          }
        ],
        "StrappingTable": tTable,
      }
    );

    var requestOptions = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': sessionToken
      },
      body: body
    };

    fetch(host + '/orgs/' + orgInfo.orgId + '/templates/', requestOptions)
      .then(async response => response.json())
      .then(data => {
        if (data.error === "OK") {
          setOrgTemplates(data.templatesList);
        }
        else {
        }
      })
      .catch(error => {
        console.log(error)
      })
  };

  const handleTableChange = (pair) => {
    if (levelVolumeTable.length < 100) {
      var data = levelVolumeTable;
      data.push({ height: parseInt(pair[0]), volume: parseInt(pair[1]) });
      data = data.sort((a, b) => a.height > b.height ? 1 : b.height > a.height ? -1 : 0);
      setLevelVolumeTable(data);
    }
    else {
      alert(t("strappingTableMustNotExceed"));
    }
  };

  function replaceTable(newTable) {
    var data = newTable;
    data = data.filter(element => element.height !== null);

    for (var i = 0; i < data.length; i++) {
      if (data[i].height == null || data[i].volume == null) {
        data = data.splice(i);
      }
    }

    data = data.sort((a, b) => a.height > b.height ? 1 : b.height > a.height ? -1 : 0);
    setLevelVolumeTable(data);
  };

  const handleTableRowDelete = (table) => {
    setLevelVolumeTable(() => {
      return [
        ...table
      ]
    });
  };

  function validateData() {
    var ret = 1;

    if (!tankTemplateName && newTemplateCheck) {
      alert(t("templateNameIncomplete"));
      ret = 0;
    } else if (newTemplateCheck) {
      for (var i = 0; i < orgTemplates.length; i++) {
        if (orgTemplates[i].name === tankTemplateName) {
          alert(t("duplicateTemplateName"));
          ret = 0;
          break;
        }
      }
    }

    if (!rtankName.current.value) {
      alert(t("tankNameIncomplete"));
      ret = 0;
    }

    if (fluidName === "") {
      alert(t("fluidNameInvalid"));
      ret = 0;
    }

    if ("vertical" === selectedTankShape) {
      if (!tankHeight) {
        alert(t("tankHeightInvalid"));
        ret = 0;
      } else if (parseFloat(tankHeight) < 1) {
        alert(t("tankHeightMustBeGreaterThan0"))
        ret = 0;
      }

      if (!tankCapacity) {
        alert(t("tankCapacityInvalid"));
        ret = 0;
      }

      if (parseFloat(rfillCapacity.current.value) > tankCapacity) {
        alert(t("fillCapcityExceeds"));
        ret = 0;
      }

      if (parseFloat(rfillCapacity.current.value) < 1) {
        alert(t("fillCapacityMustBeGreater"));
        ret = 0;
      }
    }

    if ("horizontal" === selectedTankShape) {
      if (!tankDiameter) {
        alert(t("tankDiameterInvalid"));
        ret = 0;
      } else if (parseFloat(tankDiameter) < 1) {
        alert(t("tankDiameterMustBeGreater"));
        ret = 0;
      }

      if (!tankLength) {
        alert(t("tankLengthInvalid"));
        ret = 0;
      } else if (parseFloat(tankLength) < 1) {
        alert(t("tankLengthMustBeGreater"));
        ret = 0;
      }

      if (parseFloat(rfillCapacity.current.value) > calculatedMaxCapacity) {
        alert(t("fillCapcityExceeds"));
        ret = 0;
      }

      if (parseFloat(rfillCapacity.current.value) < 1) {
        alert(t("fillCapacityMustBeGreater"));
        ret = 0;
      }
    }

    if ("obround" === selectedTankShape) {
      if (!tankHeight) {
        alert(t("tankHeightInvalid"));
        ret = 0;
      } else if (parseFloat(tankHeight) < 1) {
        alert(t("tankHeightMustBeGreaterThan0"));
        ret = 0;
      }

      if (!tankLength) {
        alert(t("tankLengthInvalid"));
        ret = 0;
      } else if (parseFloat(tankLength) < 1) {
        alert(t("tankLengthMustBeGreaterThan0"));
        ret = 0;
      }

      if (!tankWidth) {
        alert(t("tankWidthInvalid"));
        ret = 0;
      } else if (parseFloat(tankWidth) < 1) {
        alert(t("tankWidthMustBeGreaterThan0"));
        ret = 0;
      }

      if (parseFloat(rfillCapacity.current.value) > calculatedMaxCapacity) {
        alert(t("fillCapacityExceends"));
        ret = 0;
      }

      if (parseFloat(rfillCapacity.current.value) < 1) {
        alert(t("fillCapacityMustBeGreaterThan"));
        ret = 0;
      }
    }

    if ("table" === selectedTankShape) {
      if (levelVolumeTable.length === 0) {
        ret = 0;
        alert(t("enterStrappingTable"));
      } else {
        if (parseInt(rfillCapacity.current.value) > levelVolumeTable[levelVolumeTable.length - 1].volume) {
          alert(t("fillCapacityExceedsTankCapacity"));
        }

        for (var i = 0; i < levelVolumeTable.length - 1; i++) {
          if (levelVolumeTable[i].volume > levelVolumeTable[i + 1].volume) {
            ret = 0;
            alert(t("tableVolumeValuesMustIncrease"))
            break;
          }
          if (levelVolumeTable[i].volume < 0) {
            //First entry must be zero.  So zero is valid.
            ret = 0;
            alert(t("tableValuesMustNotBeNegative"));
          }
          if (levelVolumeTable[i].volume == null || levelVolumeTable[i].height == null) {
            ret = 0;
            alert(t("tableVolumeValueContains"));
          }
        }
      }
    }

    return ret;
  };

  const handleClick = async (bExit) => {
    try {
      // Get current authenticated user session
      let user = await Auth.currentAuthenticatedUser();
      user.getSession((err, session) => {
        if (err) {
          console.log("Session error");
          return;
        }

        const sessionToken = session.getIdToken().jwtToken;
        var t_Name = rtankName.current.value;
        var fillCap;

        if ("pulseHUB" === selectedTankShape) {
          fillCap = String(100);
        }
        else if (!rfillCapacity.current.value) {
          if ('vertical' === selectedTankShape) {
            fillCap = tankCapacity;
            setFillCapacity(tankCapacity);
          }
          else if ('table' === selectedTankShape) {
            fillCap = String(Math.floor(levelVolumeTable[levelVolumeTable.length - 1].volume));
            setFillCapacity(fillCap);
          }
          else {
            fillCap = String(Math.floor(calculatedMaxCapacity));
            setFillCapacity(String(Math.floor(calculatedMaxCapacity)));
          }
        }
        else {
          fillCap = rfillCapacity.current.value;
        }

        var tTable = levelVolumeTable;

        if (tTable & (tTable !== undefined || tTable.length !== 0)) {
          if (tTable[0].height !== 0 || tTable[0].volume !== 0) {
            tTable.unshift({ height: 0, volume: 0 });
          }
        }

        var tTags = rtankTag.current.value;
        var TagsList = tTags.split(",");

        for (var i = 0; i < TagsList.length; i++) {
          TagsList[i] = TagsList[i].trim();
        }

        tTags = TagsList.join();
        setTankTag(tTags);

        var body = JSON.stringify(
          {
            "Name": t_Name,
            "Fluid": fluidName,
            "Params": [
              {
                "DimensionUnit": dimensionUnit,
                "TankDiameter": tankDiameter,
                "TankLength": tankLength,
                "TankShape": selectedTankShape,
                "TankHeight": tankHeight,
                "TankWidth": tankWidth,
                "VolumeUnit": volumeUnit,
                "TankCapacity": tankCapacity,
                "FillCapacity": fillCap,
                "Tags": tTags
              }
            ],
            "StrappingTable": tTable,
            "ParentId": siteId,
            'User': user.attributes.email
          }
        );

        var dataSetValid = validateData();

        if (null === tankId && dataSetValid) {
          var requestOptions = {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': sessionToken
            },
            body: body
          };

          fetch(host + '/orgs/' + orgInfo.orgId + '/branches/' + branchInfo.branchId + '/sites/' + siteId + '/tanks', requestOptions)
            .then(async response => response.json())
            .then(data => {
              if (data.error === "OK") {
                if (newTemplateCheck) {
                  createTemplate(sessionToken, fillCap, tTable);
                }

                setTabsDataReady(0);
                setPageDataReady(0);

                let url = { pathname: ('/orgs/').concat(orgInfo.orgName).concat('/branches/').concat(branchInfo.branchName).concat('/sites/').concat(site).concat('/tanks/').concat(t_Name).concat('/edit') };
                history.push(url);
              }
              else {
                setNotification({ open: true, message: data.status });
              }
            })
            .catch(error => {
              console.log(error)
            })
        }
        else if (dataSetValid) {
          var requestOptions = {
            method: 'PUT',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': sessionToken
            },
            body: body
          };

          fetch(host + '/orgs/' + orgInfo.orgId + '/branches/' + branchInfo.branchId + '/sites/' + siteId + '/tanks/' + tankId, requestOptions)
            .then(async response => response.json())
            .then(data => {
              if (data.error === "OK") {
                if (newTemplateCheck) {
                  createTemplate(sessionToken, fillCap, tTable);
                }

                if (bExit) {
                  let url = { pathname: ('/orgs/').concat(orgInfo.orgName).concat('/branches/').concat(branchInfo.branchName).concat('/sites/').concat(site) };
                  history.push(url);
                } else {
                  if (t_Name !== tank.name) {
                    setTabsDataReady(0);
                    setPageDataReady(0);

                    let url = { pathname: ('/orgs/').concat(orgInfo.orgName).concat('/branches/').concat(branchInfo.branchName).concat('/sites/').concat(site).concat('/tanks/').concat(t_Name).concat('/edit') };
                    history.push(url);
                  }
                  else {
                    setNotification({ open: true, message: "Tank Updated" });
                    setTankData(data.tankData);
                  }
                }
              }
              else {
                alert(data.error);
              }
            })
            .catch(error => {
              console.error('Error:', error)
            })
        }
      });
    } catch (e) {
      console.log(e);
    }
  };

  React.useEffect(() => {
    createCSVData(levelVolumeTable);
  }, [levelVolumeTable]);

  function createCSVFileName(fileNamePrefix) {
    let d = new Date;
    let dformat = `${("0" + d.getDate()).slice(-2)}${("0" + (d.getMonth() + 1)).slice(-2)}${d.getFullYear()}_${d.getHours()}-${d.getMinutes()}-${d.getSeconds()}`;

    setCSVFileName(fileNamePrefix + '_StrappingTable_' + dformat + '.csv');
  };

  function createCSVData(data_in) {
    var i;
    var k;
    var csvData = [];
    var tempRow = [];

    createCSVFileName(tankName);


    for (i = 0; i < csvHeaders.length; i++) {
      tempRow.push(csvHeaders[i].label);
    }

    csvData.push(tempRow);

    if (data_in.length > 0) {
      for (k = 0; k < data_in.length; k++) {
        tempRow = []
        for (i = 0; i < csvHeaders.length; i++) {
          if (data_in[k][csvHeaders[i].key] === null || data_in[k][csvHeaders[i].key] === undefined) {
            tempRow.push("");
          }
          else {
            tempRow.push(data_in[k][csvHeaders[i].key]);
          }
        }
        csvData.push(tempRow);
      }
    }

    setCSVReportData(csvData);
  };

  return (
    <Fragment>
      <Snackbar
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        open={notification.open}
        message={notification.message}
        autoHideDuration={5000}
        onClose={handleNotificationClose} />

      <Grid container direction="row" className={classes.tankInfo}>
        <Grid item xs>
          <Grid container direction="column" justify="flex-start" className={classes.tankInfoForm}>
            <Grid item xs>
              <FormControl className={classes.formControl}>
                <TextField label={t("tankName")}
                  inputRef={rtankName}
                  value={tankName}
                  onChange={(e) => {
                    const regex = /^([\_ a-zA-Z0-9\-]){0,40}$/i;
                    if (regex.test(e.target.value)) {
                      setTankName(e.target.value);
                    }
                  }}
                />
              </FormControl>

              {(orgTemplates.length > 0) && (tankId === null) && <FormControl className={classes.formControl} >
                <TextField select
                  label={t("loadTemplate")}
                  value={selectAddTemplate}
                  helperText={" "}
                  onChange={e => {
                    for (var i = 0; i < orgTemplates.length; i++) {
                      if (e.target.value === orgTemplates[i].name) {
                        handleAddTemplate(orgTemplates[i]);
                        break;
                      }
                    }
                  }}>

                  {orgTemplates.map(orgTemplatesListItem => <MenuItem key={orgTemplatesListItem.id} value={orgTemplatesListItem.name}>
                    {orgTemplatesListItem.name}
                  </MenuItem>)}
                </TextField>
              </FormControl>}

              <div className={classes.grow}></div>
            </Grid>

            <Grid container alignContent='space-between' alignItems="center" direction='row'>
              <Grid >
                {fluids.length > 0 ? <FormControl className={classes.fluidList}>
                  <TextField select
                    label={t("fluidName")}
                    value={fluidName}
                    onChange={e => setFluidName(e.target.value)}>
                    {fluids.map((option) => (
                      <MenuItem key={option.id} value={option.name}>
                        {option.name}
                      </MenuItem>
                    ))}
                  </TextField>
                </FormControl> :
                  <FormControl className={classes.fluidList}>
                    <TextField
                      label={t("fluidName")}
                      value={t('noFluidsDefined')}
                      disabled>
                    </TextField>
                  </FormControl>}
              </Grid>
              <Grid >
                <Tooltip title={t("addFluid")}>
                  <IconButton className={classes.inputButton} aria-label={t("add")} onClick={handleClickOpen}>
                    <AddIcon />
                  </IconButton>
                </Tooltip>
              </Grid>
            </Grid>

            <Grid item xs>
              <FormControl className={classes.formControl} >
                <TextField select
                  label={t("tankShape")}
                  value={selectedTankShape}
                  onChange={e => setTankShape(e.target.value)}>
                  {tankShape.map(shape => <MenuItem key={shape.key} value={shape.key}>
                    {shape.label}
                  </MenuItem>)}
                </TextField>
              </FormControl>
            </Grid>

            <Grid item xs>
              {<FormControl className={classes.formControl} >
                <TextField select
                  label={t("dimensionsUnits")}
                  value={dimensionUnit}
                  onChange={e => setDimensionUnits(e.target.value)}>
                  {dimensionunits.map(item => (<MenuItem key={item.key} value={item.key}>{item.label}</MenuItem>))}
                </TextField>
              </FormControl>}
            </Grid>

            {(selectedTankShape === 'vertical' || selectedTankShape === 'obround') && <Grid item xs>
              <FormControl className={classes.formControl}>
                <TextField type="number" label={t("height")}
                  inputRef={rtankHeight}
                  value={tankHeight}
                  onChange={e => setTankHeight(e.target.value)}
                  helperText={dimensionUnit} />
              </FormControl>
            </Grid>
            }

            {(selectedTankShape === 'horizontal') && <Grid item xs>
              <FormControl className={classes.formControl}>
                <TextField type="number" label={t("diameter")}
                  inputRef={rtankDiameter}
                  value={tankDiameter}
                  onChange={e => setTankDiameter(e.target.value)}
                  helperText={dimensionUnit} />
              </FormControl>
            </Grid>
            }

            {(selectedTankShape === 'horizontal' || selectedTankShape === 'obround') && <Grid item xs>
              <FormControl className={classes.formControl}>
                <TextField type="number" label={t("length")}
                  inputRef={rtankLength}
                  value={tankLength}
                  onChange={e => setTankLength(e.target.value)}
                  helperText={dimensionUnit} />
              </FormControl>
            </Grid>
            }

            {selectedTankShape === 'obround' && <Grid item xs>
              <FormControl className={classes.formControl}>
                <TextField type="number" label={t("width")}
                  inputRef={rtankWidth}
                  value={tankWidth}
                  onChange={e => setTankWidth(e.target.value)}
                  helperText={dimensionUnit} />
              </FormControl>
            </Grid>
            }

            {<Grid item xs>
              <FormControl className={classes.formControl} >
                <TextField select
                  label={t("volumeUnits")}
                  value={volumeUnit}
                  onChange={e => setVolumeUnits(e.target.value)}>
                  {volumeunits.map(item => (<MenuItem key={item.key} value={item.key}>{item.label}</MenuItem>))}
                </TextField>
              </FormControl>
            </Grid>}

            {selectedTankShape === 'vertical' && <Grid item xs>
              <FormControl className={classes.formControl}>
                <TextField type="number" label={t("maxCapacity")}
                  inputRef={rtankCapacity}
                  value={tankCapacity}
                  onChange={e => setTankCapacity(e.target.value)}
                  helperText={volumeUnit} />
              </FormControl>
            </Grid>
            }

            {(selectedTankShape === 'horizontal' || selectedTankShape === 'obround') && <Grid item xs>
              <FormControl className={classes.formControl}>
                <p>{t("maximumCapacity")}:  {calculatedMaxCapacity} {volumeUnit === 'gallons' ? "gal" : "L"}</p>
              </FormControl>
            </Grid>
            }

            {(selectedTankShape !== 'pulseHUB') && <Grid item xs>
              <FormControl className={classes.formControl}>
                <TextField type="number" label={t("fillCapacity")}
                  inputRef={rfillCapacity}
                  value={fillCapacity}
                  onChange={e => setFillCapacity(e.target.value)}
                  helperText={volumeUnit === 'gallons' ? t("gallons_caps") : t("liters_caps")} />
              </FormControl>
            </Grid>
            }
          </Grid>
        </Grid>

        <Grid item xs>
          {showTankImage && tankImage !== undefined && <img edge='start'
            alt='tankImage'
            className={classes.TankImg}
            src={tankImage} />}
          {showTankImage && selectedTankShape === "vertical" && <Typography>{t("verticalCylinderOrRectangular")}</Typography>}
          {showTankImage && <Typography>{t("fillCapacityDefines")}</Typography>}
        </Grid>
        <Grid className={classes.grow}></Grid>
        <Grid className={classes.grow}></Grid>
      </Grid>

      {<Grid item xs>
        <FormControl className={classes.formControlTags}>
          <TextField label={t("tags")}
            inputRef={rtankTag}
            value={tankTag}
            onChange={(e) => {
              const regex = /^([, a-zA-Z0-9\-]){0,200}$/i;
              if (regex.test(e.target.value)) {
                setTankTag(e.target.value);
              }
            }}
            helperText={t("commaSeperated")} />
        </FormControl>

        <FormControl className={classes.formControl} >
          <TextField select
            label={t("addTags")}
            value={selectAddTag}
            helperText={" "}
            onChange={e => {
              for (var i = 0; i < orgTags.length; i++) {
                if (e.target.value === orgTags[i]) {
                  handleAddTag(orgTags[i]);
                  break;
                }
              }
            }}>

            {orgTags.map(orgTagsListItem => <MenuItem key={orgTagsListItem} value={orgTagsListItem}>
              {orgTagsListItem}
            </MenuItem>)}
          </TextField>
        </FormControl>

        <div className={classes.grow}></div>
      </Grid>}

      {selectedTankShape !== "pulseHUB" && <Grid item xs>
        <FormControlLabel className={classes.formControl} control={
          <Checkbox
            checked={newTemplateCheck}
            onChange={handleNewTemplateCheck}
            name="NewTemplateIndicator"
            color="primary"
          />
        }
          label={t("createNewTemplate")}
        />

        {newTemplateCheck && <FormControl className={classes.formControl}>
          <TextField label={t("tankTemplateName")}
            inputRef={rtankTemplateName}
            value={tankTemplateName}
            onChange={(e) => {
              const regex = /^([ a-zA-Z0-9\-]){0,40}$/i;
              if (regex.test(e.target.value)) {
                setTankTemplateName(e.target.value);
              }
            }}
            helperText={''} />
        </FormControl>}
      </Grid>}

      {(selectedTankShape === 'table') && <Grid item xs>
        <StrappingTable tankName={tankName} table={levelVolumeTable} change={handleTableChange} remove={handleTableRowDelete}
          csvFileName={csvFileName} csvReportData={csvReportData} csvHeaders={csvHeaders} replaceTable={replaceTable} />
      </Grid>
      }

      <div className={classes.btnActions}>
        <Button variant="contained" color="primary" onClick={() => handleClick(false)}>
          {t("save")}
        </Button>
        {tankId !== null && <Button className={classes.clickButtons} variant="contained" color="primary" onClick={() => handleClick(true)}>
          {t("saveAndExit")}
        </Button>}
        <Button className={classes.clickButtons} onClick={() => handleExit()}>
          {t("cancel")}
        </Button>
      </div>

      {/*Add fluid dialog*/}
      <Dialog disableBackdropClick disableEscapeKeyDown open={open} onClose={handleClose}>
        <DialogTitle>{t("addAFluid")}</DialogTitle>
        <DialogContent>
          <form className={classes.container}>
            <FormControl className={classes.formControl}>
              <TextField label={t("fluidName")}
                value={newFluidName}
                onChange={e => {
                  const regex = /^([ a-zA-Z0-9\-]){0,40}$/i;
                  if (regex.test(e.target.value)) { setNewFluidName(e.target.value) }
                }}
                inputRef={rnewFluidName} />
            </FormControl>
          </form>
        </DialogContent>

        <DialogActions>
          <Button onClick={handleClose} color="primary">
            {t("cancel")}
          </Button>
          <Button onClick={handleAddFluid} color="primary">
            {t("add")}
          </Button>
        </DialogActions>
      </Dialog>
    </Fragment>
  );
};

export default TankSettings;